var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequieres(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.652,
    height: 12.652,
    viewBox: "0 0 12.652 12.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    "data-name": "Trazado 51",
    d: "M50.164,35.9H62.816V48.551H50.164Zm0,0",
    fill: "#f9007a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disen\\u0303o_sin_ti\\u0301tulo",
    "data-name": "Disen\\u0303o sin ti\\u0301tulo",
    transform: "translate(-50.164 -35.898)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M56.421,35.828a6.327,6.327,0,1,0,6.327,6.327A6.334,6.334,0,0,0,56.421,35.828Zm.562,10.031a.9.9,0,0,1-.615.234.92.92,0,0,1-.62-.23.83.83,0,0,1-.278-.658.882.882,0,0,1,.889-.884.877.877,0,0,1,.633.257.849.849,0,0,1,.265.628A.835.835,0,0,1,56.983,45.859Zm.241-5.177-.2,2.239a1.928,1.928,0,0,1-.157.687.565.565,0,0,1-.531.329.55.55,0,0,1-.529-.327,2.226,2.226,0,0,1-.154-.7l-.146-2.185c-.028-.427-.041-.739-.041-.928a1.03,1.03,0,0,1,.254-.73.881.881,0,0,1,.671-.277.717.717,0,0,1,.709.386,2.007,2.007,0,0,1,.153.871A6.152,6.152,0,0,1,57.224,40.682Zm0,0",
    transform: "translate(0.069 0.069)",
    fill: "#f9007a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequieres);
export default __webpack_public_path__ + "static/media/requieres.054f12414088cf236683931af3077ee0.svg";
export { ForwardRef as ReactComponent };